module.exports = __webpack_public_path__ + "static/media/tela_manutencao_mobile.89fa1709.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/maintenance/tela_manutencao_mobile.jpg
// module id = 2245
// module chunks = 14